import { z } from 'zod'
import { toUidFromSchema } from 'src/util/src/uid'
import { getDuplicatesRefinement } from 'src/util/src/zod'
import { DomainSchema } from '../../DNS/models/Domain'
import { Id } from '../../Generic/models/Id'

export const SocialNetworkSchema = z.object({
  name: z.string().min(1),
  domain: DomainSchema,
})

export const SocialNetworksSchema = z.array(SocialNetworkSchema)
  .superRefine(getDuplicatesRefinement('SocialNetwork', getSocialNetworkUid))

export const SocialNetworkUidSchema = SocialNetworkSchema.pick({
  domain: true,
})

export type SocialNetwork = z.infer<typeof SocialNetworkSchema>

export type SocialNetworkUid = z.infer<typeof SocialNetworkUidSchema>

export function validateSocialNetwork(network: SocialNetwork): SocialNetwork {
  return SocialNetworkSchema.parse(network)
}

export function validateSocialNetworks(networks: SocialNetwork[]): SocialNetwork[] {
  return SocialNetworksSchema.parse(networks)
}

export function getSocialNetworkUid(networkUid: SocialNetworkUid) {
  return toUidFromSchema(networkUid, SocialNetworkUidSchema)
}
